//@actions
const actionTypes = require('constants/actionTypes');

const setActiveTab = (tabIndex) => ({
    type: actionTypes.BROKER_LANDING_CHANGE_TAB,
    payload: {
        tab : tabIndex
    }
});

const resetActiveTab = () => ({
    type: actionTypes.BROKER_LANDING_RESET_TAB
});

module.exports = {
    setActiveTab,
    resetActiveTab
};